<div class="progress-wrapper" [hidden]="!show">
  <mat-spinner [diameter]="44" [strokeWidth]="4"></mat-spinner>
</div>
